import { Box, Typography, Dialog, Button, Paper, useTheme } from '@mui/material'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { Icons, exportAttendanceReport, secondsToHMS } from '../../utils/utilities'
import CustomSearchBar from '../../components/common/CustomSearchBar'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import BlockMessage from '../../components/common/BlockMessage'
import noAttendenceImg from '../../assets/noattendence.svg'
import SelectImg from '../../assets/selectinstitute.svg'
import { useUserStore } from '../../store/user.store'
import React, { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import api from '../../service/api'
import dayjs from 'dayjs'
import CustomChip from '../../components/common/CustomChip'
import CustomTable from '../../components/common/custom-table/CustomTable'

const snapsSortFunc = ( a, b, values ) => {
    let fa = +( values[a].replace( /:/g, "" ) )
    let fb = +( values[b].replace( /:/g, "" ) )
    return fa > fb ? 1 : -1
}

const columns = [
    { field: 'selected_date', filterable: true, sortable: true, name: 'Date', width: 130 },
    { field: 'subject_name_short', filterable: true, name: 'Subject', width: 160 },
    { field: 'institute', filterable: true, name: 'Institute', width: 160 },
    { field: 'branch_name', filterable: true, name: 'Branch', width: 160 },
    { field: 'presenter', filterable: true, name: 'Presenter', width: 160 },
    { field: 'interval', filterable: true, name: 'Duration', width: 190 },
    { field: 'attendance', sortable: true, renderCell: row => row.attendees?.length || 0, dataType: "number", name: 'Attendance', width: 100 }, //selected_date
]

export default function AttendanceAudit () {
    const [loading, setLoading] = React.useState( false )
    const [allAttendance, setAllAttendance] = React.useState( [] )
    const [hasPermission, setHasPermission] = useState( true )
    const [fromDate, setFromDate] = React.useState( new Date().toISOString() )
    const [toDate, setToDate] = React.useState( new Date().toISOString() )
    const [openDialog, setOpenDialog] = React.useState( false )
    const [selectedClassAttendanceDetails, setSelectedClassAttendanceDetails] = React.useState( null )
    const [isExporting, setIsExporting] = useState( false )
    const [isAttendanceFetched, setIsAttendanceFetched] = useState( false )
    const [attendanceSearchValue, setAttendanceSearchValue] = useState( '' )

    const UserStore = useUserStore()

    const { border, palette, components, layout } = useTheme()

    const submit = async () => {
        setIsAttendanceFetched( true )
        let payload = {
            "date_from": fromDate.toString().split( "T" )[0],
            "date_to": toDate.toString().split( "T" )[0]
        }
        setLoading( true )
        try {
            const res = await api.attendenceAudit( payload )
            setAllAttendance( res["data"]["data"] ? res["data"]["data"] : [] )
        } catch ( error ) {
            console.log( error )
        } finally {
            setLoading( false )
        }
    }

    const searchFilterFunc = item => {
        const searchValue = new RegExp( attendanceSearchValue?.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' ), 'i' )
        return Boolean( item?.user_id?.match( searchValue ) )
    }

    const exportReport = async () => {
        setIsExporting( true )
        await exportAttendanceReport( allAttendance, new Date( fromDate ).toLocaleDateString( 'en-IN' ).replace( /\//g, "-" ), new Date( toDate ).toLocaleDateString( 'en-IN' ).replace( /\//g, "-" ) )
        setIsExporting( false )
    }

    const showAuid = ( row ) => {
        const { selected_date, attendees, total_duration, attendance_version, title, interval, course, presenter } = row
        setSelectedClassAttendanceDetails( {
            course,
            presenter,
            interval,
            title,
            selected_date,
            attendance_version,
            total_time: total_duration,
            attendees: attendees.sort( ( a, b ) => b.present_percentage - a.present_percentage )
        } )

        setOpenDialog( true )
    }

    const handleClose = () => {
        setOpenDialog( false )
        setSelectedClassAttendanceDetails( null )
        if ( attendanceSearchValue )
            setAttendanceSearchValue( '' )
    }

    useEffect( () => {
        if ( UserStore.getUser.user_role === 'SUBADMIN' && !UserStore.getUser.user_permissions.attendance_audit ) {
            setHasPermission( false )
        }
    }, [UserStore] )

    return ( hasPermission ? <Box padding={layout.pagePadding} overflow="auto" flexGrow={1} display="flex" flexDirection="column" >
        <Box flexGrow={1} gap={layout.sectionsGap} sx={{ display: "flex", flexDirection: "column" }}>
            <Box>
                <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Attendance Audit</Typography>
                <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>View all the online classes attendance details</Typography>
                <Typography marginTop="20px" gutterBottom variant="subtitle2" component="h2">
                    Select Date Range
                </Typography>
                <Box sx={{ display: "flex", flexWrap: 'wrap', gap: "10px", marginTop: "5px" }}>
                    <Box sx={{ alignItems: "center", display: "flex", gap: "10px", flexWrap: "wrap" }} noValidate autoComplete="off">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                {...( components?.MuiPickerOutlinedInput?.defaultProps || {} )}
                                disableToolbar
                                variant="inline"
                                format="DD-MM-YYYY"
                                sx={{ fontSize: "12px", '& input': { padding: "10px" }, flexGrow: 1 }}
                                margin="normal"
                                id="fromdate-picker-inline"
                                value={dayjs( fromDate )}
                                onChange={( e ) => setFromDate( e.toISOString() )}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}

                            />
                        </LocalizationProvider>
                        <Typography color="textSecondary" display={{ md: "block", xs: "none" }} width="fit-content" variant='subtitle2'>-</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                {...( components?.MuiPickerOutlinedInput?.defaultProps || {} )}
                                disableToolbar
                                // maxDate={dayjs( new Date() ).add( 1, 'day' )}
                                sx={{ fontSize: "12px", '& input': { padding: "10px" }, flexGrow: 1 }}
                                variant="inline"
                                format="DD-MM-YYYY"
                                margin="normal"
                                id="todate-picker-inline"
                                // label="To Date"
                                value={dayjs( toDate )}
                                // onAccept={( e ) => setFromDate( e.toISOString() )}
                                onChange={( e ) => setToDate( e.toISOString() )}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}


                            />
                        </LocalizationProvider>
                    </Box>
                    <Button variant='contained' disableElevation sx={{ width: { xs: "100%", md: "fit-content" } }} color="primary" onClick={submit}>
                        Search
                    </Button>
                </Box>
            </Box>
            {allAttendance.length > 0 && !loading && <Box flexGrow={1}>
                {selectedClassAttendanceDetails && selectedClassAttendanceDetails.attendees.length > 0 && <Dialog fullWidth={true} maxWidth={'md'} onClose={handleClose} aria-labelledby="simple-dialog-title" open={openDialog} slotProps={{
                    paper: { sx: { position: "relative" } }
                }}>
                    <Box borderBottom={border[1]} top="0" position="sticky" zIndex={10} bgcolor={palette.background.paper} >
                        <Box display="flex" flexWrap="wrap" gap="10px" justifyContent="space-between" alignItems="center" padding="10px 20px">
                            <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Attendance List</Typography>
                            <CustomSearchBar width='250px' placeholder='Search by AUID.' icon={Icons.default.SearchIcon} value={attendanceSearchValue} onChange={e => setAttendanceSearchValue( e.target.value )} border={border[1]} />
                        </Box>
                        {selectedClassAttendanceDetails.attendance_version === "2.0" && <Box padding="20px" bgcolor={palette.contentBg}>
                            <Typography variant="subtitle2" display="block" component="h1">{selectedClassAttendanceDetails.title}</Typography>
                            <Box display="flex" flexWrap="wrap" gap="10px">
                                <CustomChip value={`Date: ${dayjs( selectedClassAttendanceDetails.selected_date ).format( "DD-MM-YYYY" )}`} />
                                <CustomChip value={`Time Interval: ${selectedClassAttendanceDetails.interval}`} />
                                <CustomChip value={`Total Duration: ${secondsToHMS( selectedClassAttendanceDetails.total_time / 1000, false )}`} />
                            </Box>
                        </Box>}
                        {selectedClassAttendanceDetails.attendance_version === "1.0" && <Box padding="20px" bgcolor={palette.contentBg}>
                            <Typography variant="subtitle2" display="block" component="h1">{selectedClassAttendanceDetails.presenter}-{selectedClassAttendanceDetails.course}</Typography>
                            <Box display="flex" flexWrap="wrap" gap="10px">
                                <CustomChip value={`Date: ${dayjs( selectedClassAttendanceDetails.selected_date ).format( "DD-MM-YYYY" )}`} />
                                <CustomChip value={`Time Interval: ${selectedClassAttendanceDetails.interval}`} />
                            </Box>
                        </Box>}

                    </Box>
                    <Box paddingBottom="20px" display="flex" flexDirection="column">


                        {selectedClassAttendanceDetails.attendees.filter( searchFilterFunc )?.map( ( attendee ) => (
                            <Box sx={{ ":hover": { background: palette.rowHover } }} padding="10px 20px" borderTop={border[1]} key={attendee.user_id}>
                                <Typography gutterBottom={Boolean( selectedClassAttendanceDetails.attendees )} display="block" component="h2" variant='subtitle2'>{attendee.user_id} {attendee.user_id?.length < 10 ? `(host)` : ""} </Typography>
                                <Box display="flex" flexWrap="wrap" gap="10px" alignItems="center">
                                    <CustomChip value={attendee.present_percentage > 50 ? "P" : "A"} variant='filled' color={attendee.present_percentage > 50 ? "success" : "error"} />
                                    {selectedClassAttendanceDetails.attendance_version === "2.0" && <CustomChip value={`Time spent: ${secondsToHMS( attendee.time_spent / 1000, false )}`} />}
                                    <CustomChip value={`Present Percentage: ${attendee.present_percentage}%`} />
                                </Box>
                            </Box>
                        ) )}
                        {selectedClassAttendanceDetails.attendees.filter( searchFilterFunc )?.length === 0 && <Box sx={{ flexGrow: 1, padding: "20px", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", gap: "10px" }}>
                            <Box component="img" width="180px" src={noAttendenceImg} alt="remove-filters"></Box>
                            <Typography variant='subtitle2' color="textSecondary">No students ID matches `<em>{attendanceSearchValue}</em>`</Typography>
                        </Box>}
                    </Box>
                </Dialog>}
                <Box>
                    <Box display="flex" gap="10px" marginBottom="10px" alignItems="flex-end" justifyContent="space-between">
                        <Typography variant='subtitle2'>Attendance details from {new Date( fromDate ).toLocaleDateString( 'en-IN' ).replace( /\//g, "-" )} to {new Date( toDate ).toLocaleDateString( 'en-IN' ).replace( /\//g, "-" )}</Typography>
                        <Button disableElevation onClick={exportReport} startIcon={isExporting ? Icons.default.DownloadForOfflineIcon : Icons.default.Upload} disabled={isExporting} variant='outlined' color='secondary' sx={{ textTransform: "capitalize", flexShrink: 0 }}>Export as excel</Button>
                    </Box>
                    <CustomTable data={allAttendance} onRowClick={showAuid} columns={columns} />
                </Box>
            </Box>}

            {allAttendance.length === 0 && !loading && isAttendanceFetched &&
                <Box sx={{ flexGrow: 1, padding: "20px", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}>
                    <img src={noAttendenceImg} width="150px" alt="No attendence details for selected date range!" />
                    <Typography color="textSecondary" variant="subtitle2" marginY="20px">No attendence details for selected date range!</Typography>
                </Box>
            }
            {allAttendance.length === 0 && !loading && !isAttendanceFetched &&
                <Box bgcolor={palette.contentBg} border={border[1]} borderRadius={layout.borderRadius} sx={{ flexGrow: 1, padding: "20px", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}>
                    <img src={SelectImg} width="150px" alt="Select a date range to get attendance report!" />
                    <Typography variant='subtitle2' color="textSecondary" marginY="20px">Select a date range to get attendance report!</Typography>
                </Box>
            }
            {loading && <Box>
                <DataLoadingSpinner waitingMessage="Loading attendance data..." />
            </Box>}
        </Box>
    </Box> : <Box padding="20px">
        <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
    </Box> )
}
